import { render, staticRenderFns } from "./AdditionalQuestionForProfiles.vue?vue&type=template&id=081bb6e4&scoped=true&"
import script from "./AdditionalQuestionForProfiles.vue?vue&type=script&lang=js&"
export * from "./AdditionalQuestionForProfiles.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalQuestionForProfiles.vue?vue&type=style&index=0&id=081bb6e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081bb6e4",
  null
  
)

export default component.exports